import useFormatterPrice from '@/src/utils/formatter-price';
import { IoMdPricetag } from 'react-icons/io';
import { MdGavel } from 'react-icons/md';
import getAdPrice from '@/src/utils/getAdPrice';

export default function PriceTag({ ad }: { ad: any }) {
  const initPrice = getAdPrice(ad);
  const auctionPrice = 0;
  const price = Math.max(initPrice, auctionPrice);
  const formatterPrice = useFormatterPrice();

  return (
    <div className='absolute right-0 top-12 z-20 flex items-center gap-1 rounded-l bg-brand px-2 py-1 font-bold uppercase leading-tight text-black'>
      <span className='text-md'>
        {ad.is_auction ? (
          <span style={{ transform: 'rotateY(180deg)' }}>
            <MdGavel />
          </span>
        ) : (
          <IoMdPricetag />
        )}
      </span>
      {formatterPrice(price)}
    </div>
  );
}
